import { GetterTree } from 'vuex';
import { RootState } from '@/plugins/store';
import { AccountState } from './state';

export const getters: GetterTree<AccountState, RootState> = {
    getSocieteIds(state) {
        return state.societeIds;
    },
};
